/// <reference path="../interfaces.ts" />
import React from "react";

namespace Dashboard {
    interface Props {
        content: string;
    }


    export const FreeText: React.FC<Props> = ({content}) => {
        return <div dangerouslySetInnerHTML={{ __html: content }} />;
    };
}

export default Dashboard.FreeText;
